
jQuery(function($) {
    
    var l_window = $(window).width();
    /******************************************/
    /********** LIGHTBOX VIDEO HOME PAGE *************/
  /******************************************/


   if($(".open-popup-link"). length){
   // videojs.options.flash.swf = "video-js.swf";
    $('document').ready(function(){
      $('.open-popup-link').magnificPopup({
        type:'inline',
        midClick: true,
        mainClass: 'mfp-fade',
        callbacks: {
        open: function() {
           videojs('pres_lightbox').play();
        },
        close: function() {
          videojs('pres_lightbox').pause();
        }
        // e.t.c.
      }

      });
    });
  }



  const anim_txt_jaune = gsap.utils.toArray('.anim-txt-container');
  anim_txt_jaune.forEach((btn) => {

    gsap.from(btn, {
      scrollTrigger: {
        start: 'top bottom',
        end: 'bottom top',
        trigger: btn,
        toggleClass: 'enable'
      }
    });
  });

   gsap.utils.toArray('.keyfigures-item').forEach((section, index) => {
     
     // const w = section.querySelector('.wrapper');
     // const [x, xEnd] = (index % 2) ? ['0%', (w.scrollWidth - section.offsetWidth) * -1] : ['-50%', '-5%']; // 50% ou 0
   
       gsap.from(section, {
        scrollTrigger: {
          start: 'top bottom',
          end: 'bottom top',
          trigger: section,
          toggleClass: 'enable'
        }
      });

  });

  
    
    
     if(l_window > 1023){
    /* Anim form grise dans les pages */
    const anim_etoile_grise_inner_page = gsap.utils.toArray('.anim-js-scroll');
    anim_etoile_grise_inner_page.forEach((shape) => {

      gsap.from(shape, {
        scrollTrigger: {
          start: 'top bottom',
          end: 'bottom top',
          trigger: shape,
          toggleClass: 'enable'
        }
      });
    });
  }



  $(".counts").each(function(index, element) {
      var count = $(this),
          zero = {val:0},
          num = count.data("number"),
          split = (num + "").split("."),
          decimals = split.length > 1 ? split[1].length : 0;

        gsap.to(zero, {
          val: num,
          duration: 3,
          scrollTrigger: element,
          onUpdate: function() {
            count.text(zero.val.toFixed(decimals));
          }
        });
  }); 



  /* ********************************************** */
  /* **** ACTIVATION DU BON SOUS-MENU DANS MENU PRINCIPAL ************* */
  /* ********************************************** */
      
       // Cache selectors
       var lastId,
      start_url = '',
      topMenuHeight = 90;

      if(l_window > 1220){
        topMenuHeight = 40;
      }
      // All list menuItems
      menuItems = $("#primary-menu > li.current_page_ancestor > ul a");

      // Anchors corresponding to menu items
     var scrollItems = menuItems.map(function(){

        var item = $("#"+$(this).attr("href").split("#")[1]);
        start_url = $(this).attr("href").split("#")[0];
        if (item.length) {return item;}
      });


    // Bind to scroll
    $(window).scroll(function(){
     // Get container scroll position
     var fromTop = $(this).scrollTop();
    
     // Get id of current scroll item
     var cur = scrollItems.map(function(){
        variable_top = 10;
       if ($(this).offset().top - topMenuHeight - variable_top < fromTop)
       {

         return this;
       }
     });
     // Get the id of the current element
     cur = cur[cur.length-1];
     var id = cur && cur.length ? cur[0].id : "pour_quoi";
     if (lastId !== id) {
         lastId = id;
         // Set/remove active class
         menuItems.removeClass("active");
         menuItems.filter("a[href='"+start_url+"#"+id+"']").addClass("active");
     }else{
      menuItems.filter("a[href='"+start_url+"#pour_quoi']").addClass("active");
     }                 
  });


  // ** //
  // AU RECHARGEMENT OU AU SCROLL DE LA PAGE = ON FAIT SCROLL SMOOTH VERS LA POSITION // 
  // ** // 
  function scroll_good_anchor(){
     if(window.location.hash) {
      var $hash_location = window.location.hash;
      if($($hash_location).length){
         var offsetTop = $hash_location === "#" ? 0 : $($hash_location).offset().top-topMenuHeight;
          $('html, body').stop().animate({ 
              scrollTop: offsetTop
          }, 500);
      }
    } 
  }

  scroll_good_anchor();



  /* ******************* */
   /* CLICK SUR UN SOUS-MENU DANS LA PAGE BOOSTER ? */
   /* ******************* */
    $('body').on('click', "#primary-menu li ul li a", function(e) {     
    
        var $current_url = document.URL.split("#");
        var url_withour_anchor= $current_url[0].substring(5); // remove http: (OU HTTPS attention ! )
          // si il y a un # dans l'url et que la base de l'url est la meme
          if($(e.target).is('a')){
          if ($(e.target).attr('href').indexOf("#") != -1 && $(e.target).attr('href').indexOf(url_withour_anchor) > -1) {
              var anchor_url = $(e.target).attr('href').split("#");
              var $hash_location = $("#"+anchor_url[1]);
             if($($hash_location).length){
              var offsetTop = $hash_location === "#" ? 0 : $($hash_location).offset().top - topMenuHeight;
 
                 if($("#site-navigation").hasClass('toggled')){
                  $( ".menu-toggle" ).trigger( "click" );
                }

                $('html, body').stop().animate({ 
                    scrollTop: offsetTop
                }, 500);

                e.preventDefault();
          }   
          }
        }
      
    });




  /************************************************/
  /*********** BACK TO TOP *******************/
    
  $(document).ready(function(){"use strict";
    //Scroll back to top
    var progressPath = document.querySelector('.progress-wrap path');
    var pathLength = progressPath.getTotalLength();
    progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
    progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
    progressPath.style.strokeDashoffset = pathLength;
    progressPath.getBoundingClientRect();
    progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';    
    var updateProgress = function () {
      var scroll = $(window).scrollTop();
      var height = $(document).height() - $(window).height();
      var progress = pathLength - (scroll * pathLength / height);
      progressPath.style.strokeDashoffset = progress;
    };
    updateProgress();
    $(window).scroll(updateProgress); 
    var offset = 50;
    var duration = 550;
    jQuery(window).on('scroll', function() {
      if (jQuery(this).scrollTop() > offset) {
        jQuery('.progress-wrap').addClass('active-progress');
      } else {
        jQuery('.progress-wrap').removeClass('active-progress');
      }
    });       
    jQuery('.progress-wrap').on('click', function(event) {
      event.preventDefault();
      jQuery('html, body').animate({scrollTop: 0}, duration);
      return false;
    }); 
  }); 


   /******************************************/
    /******* SLIDER HOTSPOT POUR MOBILE - PAGE ENTREPRISE *****/
    /******************************************/
       if ( $( ".schema-12-champs-actions" ).length ) {  

      $('.js-slider-schema-infos').slick({
          arrows: true,
          autoplay:true,
          autoplaySpeed: 4000,
          slidesToScroll: 2,
          slidesToShow: 2,
          dots:false,
          pauseOnFocus:false,
          pauseOnHover:false,
          infinite:true,
          mobileFirst: true,
          responsive: [
          {
                breakpoint: 1023,
                settings: 'unslick'
          },
          {
                breakpoint: 768,
                slidesToShow: 3,
                slidesToScroll: 3,
          },
        ]
    });

    }

    if($('.EditoProjetRowCours').length){
       gsap.from($('.EditoProjetRowCours img'), {
        y:"-20%",
        scrollTrigger: {
          // start: 'top bottom',
          // end: 'bottom top',
          scrub:true,
          trigger: $('.EditoProjetRowCours'),
         
        }
      });
    }
    
    

      /******************************************/
    /******* CHARGEMENT PLUS DE PROJET TERMINES *****/
    /******************************************/

    $.fn.wpPagination = function( options ) {
      options = $.extend({
        links: "a",
        action: "pagination",
        ajaxURL: object_var.ajaxurl,
        next: ".next"
      }, options);
    
      function WPPagination( element ) {
        this.$el = $( element );
        this.init();
      }
      
      WPPagination.prototype = {
        init: function() {
          this.createLoader();
          this.handleNext();
          this.handleLinks();
        },
        createLoader: function() {
          var self = this;
          $('#pagination').prepend( "<span id='pagination-loader' class='loader-spinner'></span>" );
          $('#pagination-loader').hide();
        },
        handleNext: function() {
          var self = this;
          var $next = $( options.next, self.$el );
        },
        handleLinks: function() {
          var self = this,
          $links = $( options.links, self.$el ),
          $pagination = $( "#pagination" );
          $loader = $( "#pagination-loader" );
          
          $links.click(function( e ) {
            e.preventDefault();

            $('#pagination .next').fadeOut();
            $loader.fadeIn();

            var $a = $( this ),
            url = $a.attr("href"),
            notin = $a.attr('data-not-in'),
            page = url.match( /\d+/ ),
            pageNumber = page[0],
            data = {
              action: options.action,
              page: pageNumber,
              notin : notin
            };

            
            $.get( options.ajaxURL, data, function( html ) {
              $('.container-resume-project-t').append( "<div class='sep-page' id='page-" + pageNumber + "'></div>" );
              $('.container-resume-project-t').append( html );
              $a.attr("href", url.replace('/' + pageNumber + '/', '/' + ( parseInt(pageNumber) + 1 ) + '/'));
              
              if ( !html ) {
                $loader.fadeOut();
                $('#pagination').fadeOut();
              } else {
                $loader.fadeOut();
                $('#pagination .next').fadeIn();
                 var offsetTop = $('#page-' + pageNumber).offset().top-topMenuHeight;
                 $('html, body').stop().animate({ 
                      scrollTop: offsetTop
                  }, 500);
              }
            });
          });
        }
      };
      
      return this.each(function() {
        var element = this;
        var pagination = new WPPagination( element );
      });
    };
    
    $(function() {
      if( $( "#pagination" ).length ) {
        $( "#pagination" ).wpPagination();
      }
    });


     /******************************************/
    /******* SLIDER PROJET EN COURS *****/
    /******************************************/
      if ( $( ".js-slider-projet-en-cours" ).length ) {  

      $('.js-slider-projet-en-cours').slick({
          arrows: true,
          autoplay:true,
          autoplaySpeed: 4000,
          slidesToScroll: 1,
          slidesToShow: 1,
          dots:false,
          pauseOnFocus:false,
          pauseOnHover:false,
          infinite:true,
          responsive: [
          {
                breakpoint: 1025,
                settings: {
                   slidesToScroll: 2,
                   slidesToShow: 2
                }
          },
          {
                breakpoint: 700,
                settings: {
                   slidesToScroll: 1,
                   slidesToShow: 1
                }
          }
          ]

    });

    }

     /******************************************/
    /******* SLIDER PARTENAIRES *****/
    /******************************************/

   
    if ( $( ".js-slider-partenaire" ).length ) {  

      $('.js-slider-partenaire').slick({
          arrows: false,
          autoplay:true,
          autoplaySpeed: 4000,
          slidesToScroll: 5,
          slidesToShow: 5,
          dots:true,
          pauseOnFocus:false,
          pauseOnHover:false,
          infinite:true,
          responsive: [
          {
                breakpoint: 1025,
                settings: {
                   slidesToScroll: 4,
                   slidesToShow: 4
                }
          },
          {
                breakpoint: 769,
                settings: {
                   slidesToScroll: 3,
                   slidesToShow: 3
                }
          },
          {
                breakpoint: 500,
                settings: {
                   slidesToScroll: 3,
                   slidesToShow: 3
                }
          }
          ]

    });

    }



    


    // FORM CONTACT LABEL ///

  $( ".wpcf7-form p.m_move label" ).click(function() {
      $( this ).parent().addClass('focus');
  });

  $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });




 });

var mzOptions = {};
  mzOptions = {
      onZoomReady: function() {
          
        // ex // schema

        gsap.utils.toArray('.anim-to-change-class').forEach((section, index) => {
         
         // const w = section.querySelector('.wrapper');
         // const [x, xEnd] = (index % 2) ? ['0%', (w.scrollWidth - section.offsetWidth) * -1] : ['-50%', '-5%']; // 50% ou 0
       
           gsap.from(section, {
            scrollTrigger: {
              start: 'top bottom',
              end: 'bottom top',
              trigger: section,
              toggleClass: 'enable'
            }
          });

      });


      const anim_txt_jaune = gsap.utils.toArray('.anim-txt-container-after');
        anim_txt_jaune.forEach((btn) => {

          gsap.from(btn, {
            scrollTrigger: {
              start: 'top bottom',
              end: 'bottom top',
              trigger: btn,
              toggleClass: 'enable'
            }
          });
        });

          
      },
 };


 //load_page
